// Platform-specific exports
import { Platform } from 'react-native';
import { MainNavWeb } from './MainNav.web';
import { MainNavNative } from './MainNav.native';

export const MainNav = Platform.OS === 'web' ? MainNavWeb : MainNavNative;

